import { Action } from "../../../actions/actions";
import { HallsActionTypes } from "../actions/actionTypes";
import { OSMAdress } from "../../../types/addressTypes";
import { AddressUtils } from "../../../utils/addressUtils";

export function creatingHall(state: any = null, action: Action) {
    const values =
        state && action.payload
            ? { ...state.values, ...action.payload.values }
            : action.payload
            ? action.payload.values
            : null;

    const isValid = state && action.payload ? action.payload.isValid : false;

    switch (action.type) {
        case HallsActionTypes.UPDATE_CREATING_HALL:
            return {
                values,
                isValid: isValid
            };

        case HallsActionTypes.PICK_SUGGESTION:
            return {
                values: {
                    ...state.values,
                    address_line_1: AddressUtils.addressFromSuggestion(
                        action.payload.suggestion
                    ).line1,
                    address_line_2: AddressUtils.addressFromSuggestion(
                        action.payload.suggestion
                    ).line2
                },
                isValid:
                    values.name &&
                    values.name.length <= 50 &&
                    values.address_line_1 &&
                    values.address_line_1.length <= 200 &&
                    values.address_line_2 &&
                    values.address_line_2.length <= 200 &&
                    values.subsidiary
            };

        case HallsActionTypes.CREATE_HALL_SUCCESS:
            return null;

        case HallsActionTypes.CREATE_HALL_RESET:
            return null;

        default:
            return state;
    }
}

export function addressSuggestions(state: OSMAdress[] = [], action: Action) {
    switch (action.type) {
        case HallsActionTypes.UPDATE_SUGGESTIONS_FAIL:
        case HallsActionTypes.CREATE_HALL:
        case HallsActionTypes.PICK_SUGGESTION:
        case HallsActionTypes.CREATE_HALL_RESET:
            return [];

        case HallsActionTypes.UPDATE_SUGGESTIONS_SUCCESS:
            return action.payload.results;

        default:
            return state;
    }
}

export function pickedSuggestionCount(state: number = 0, action: Action) {
    switch (action.type) {
        case HallsActionTypes.PICK_SUGGESTION:
            return state + 1;

        default:
            return state;
    }
}

export function submittingHallLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case HallsActionTypes.CREATE_HALL:
        case HallsActionTypes.UPDATE_HALL:
            return true;
        case HallsActionTypes.CREATE_HALL_SUCCESS:
        case HallsActionTypes.CREATE_HALL_FAIL:
        case HallsActionTypes.UPDATE_HALL_SUCCESS:
        case HallsActionTypes.UPDATE_HALL_FAIL:
            return false;
        default:
            return state;
    }
}
